<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Rating Plan</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Rating Plan</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <img src="/assets/images/loader.svg" alt="" />
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'RatingPlanList' }"
                >
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body table-responsive p-0">
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <td><b>ID</b></td>
                    <td>{{ value.id }}</td>
                  </tr>

                  <tr>
                    <td><b>Name</b></td>
                    <td>{{ value.name }}</td>
                  </tr>

                  <tr>
                    <td><b>Alias</b></td>
                    <td>{{ value.alias }}</td>
                  </tr>

                  <tr>
                    <td><b>Description</b></td>
                    <td>{{ value.description }}</td>
                  </tr>

                  <tr>
                    <td><b>Status</b></td>
                    <td>{{ value.status }}</td>
                  </tr>

                  <tr>
                    <td><b>App-ID</b></td>
                    <td>{{ value.app_id }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { CBSProductRatingApi } from "@/services/api";

export default {
  name: "RatingPlanShow",
  data: () => ({
    value: {},
    pre: {},
    is_loading: false,
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      this.getDetail(this.params.id);
      this.is_loading = false;
    },
    getDetail: function (id) {
      CBSProductRatingApi.showRatingPlan(id)
        .then((item) => {
          this.value = item;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
};
</script>
